import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StudentState } from '../reducers/student.reducer';
import { STUDENT_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<StudentState>(STUDENT_FEATURE_KEY);

export const selectStudent = (id: string) => createSelector(selectState, (state) => state.entries[id]?.student ?? null);
export const selectLoaded = (id: string) => createSelector(selectState, (state) => state.entries[id]?.loaded ?? null);
export const selectLoading = (id: string) => createSelector(selectState, (state) => state.entries[id]?.loading ?? false);
export const selectSaved = createSelector(selectState, (state) => state.saved);
export const selectSaving = createSelector(selectState, (state) => state.saving);
